// Reconcile the anonymous /providers shortlist into the account at auth.
//
// Anonymous saves live in localStorage (see landing/lib/shortlist.js). On any
// login or registration we claim those ids to the authenticated account via
// POST /provider/saved-listings/claim (idempotent, never fires recruiter
// contact), then clear the local store so the same ids are not re-claimed on
// every subsequent login. A no-op when the shortlist is empty (the common
// case), so it costs nothing on ordinary logins.

import { getBackendUrl } from '../utils/apiUrl';
import { readShortlistIds, writeShortlistIds } from '../landing/lib/shortlist';

/**
 * @param {string} authToken - a fresh JWT
 * @returns {Promise<{ claimed: number } | null>} null when there was nothing to claim
 */
export const reconcileShortlist = async (authToken) => {
  if (!authToken) return null;
  const ids = readShortlistIds();
  if (!ids.length) return null;

  try {
    const res = await fetch(`${getBackendUrl()}/provider/saved-listings/claim`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ listingIds: ids }),
    });
    if (!res.ok) return null;
    // Clear only after a confirmed claim so a failed request keeps the saves
    // for the next login attempt.
    writeShortlistIds([]);
    return { claimed: ids.length };
  } catch {
    // Reconcile is best-effort: never block or break the auth flow.
    return null;
  }
};
